import { useAppSelector } from "./useAppSelector";

function useSelectedRowKey(){
    const {selectedRowKeys } = useAppSelector((state) => state.table)
    return selectedRowKeys;
}
    

export default useSelectedRowKey;